export const QueryKey = {
	content: 'content',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
